export default __webpack_public_path__ + "static/media/logout.11b20729.png";